import { render, staticRenderFns } from "./ChatTypeTabs.vue?vue&type=template&id=167be048&"
import script from "./ChatTypeTabs.vue?vue&type=script&lang=js&"
export * from "./ChatTypeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167be048')) {
      api.createRecord('167be048', component.options)
    } else {
      api.reload('167be048', component.options)
    }
    module.hot.accept("./ChatTypeTabs.vue?vue&type=template&id=167be048&", function () {
      api.rerender('167be048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ChatTypeTabs.vue"
export default component.exports